import { fromHex, toHex } from '@polkadot-api/utils';
import { createCodec, Bytes } from 'scale-ts';

const enc = (nBytes) => {
  const _enc = Bytes.enc(nBytes);
  return (value) => _enc(fromHex(value));
};
const dec = (nBytes) => {
  const _dec = Bytes.dec(nBytes);
  return (value) => toHex(_dec(value));
};
const Hex = (nBytes) => createCodec(enc(nBytes), dec(nBytes));
Hex.enc = enc;
Hex.dec = dec;

export { Hex };
//# sourceMappingURL=Hex.mjs.map
